export default __webpack_public_path__ + "static/media/gdsclogo.c18a8ea1.svg";